<template>
	<div>
		<el-card>
			<div class="top">
				<div class="top2">
					当日充值次数：{{ incomeInfo.day.pay_num }}
				</div>
				<div class="top2">
					当月充值次数：{{ incomeInfo.month.pay_num }}
				</div>
				<div class="top2">
					充值总次数：{{ incomeInfo.all.pay_num }}
				</div>
			</div>
			<div class="top">
				<div class="top2">
					当日充值人数：{{ incomeInfo.day.pay_user }}
				</div>
				<div class="top2">
					当月充值人数：{{ incomeInfo.month.pay_user }}
				</div>
				<div class="top2">
					充值总人数：{{ incomeInfo.all.pay_user }}
				</div>
			</div>
			<div class="top">
				<div class="top2">
					当日充值金额：{{ incomeInfo.day.pay_money }}
				</div>
				<div class="top2">
					当月充值金额：{{ incomeInfo.month.pay_money }}
				</div>
				<div class="top2">
					充值总金额：{{ incomeInfo.all.pay_money }}
				</div>
			</div>
		</el-card>
		<el-card>
			<el-form :model="form" ref="form" :inline="true">
				<!-- <el-form-item label="收益类型:">
					<el-checkbox-group v-model="form.checkList">
						<el-checkbox v-for="item in typelist" :key="item.type" :label="item.type">{{item.name}}
						</el-checkbox>

					</el-checkbox-group>
				</el-form-item> -->
				<el-form-item label="订单编号:">
					<el-input placeholder="请输入订单编号" v-model="form.orderid" style="width: 350px;"></el-input>
				</el-form-item>
				<el-form-item label="流水日期:">
					<el-date-picker v-model="form.time" type="daterange" range-separator="至" start-placeholder="开始日期"
						end-placeholder="结束日期">
					</el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="submitForm()">查询</el-button>
				 <el-button @click="resetForm()">重置</el-button>
				</el-form-item>
			</el-form>
			<!-- <div class="runmoney">
				<h4>用户总充值金额（元）</h4>
				<h2>{{runmoney}}</h2>
			</div> -->
		</el-card>
		
		<el-card>
			<el-table :data="tableData" style="width: 100%">
				<el-table-column type="index" width="50">
				</el-table-column>
				
				<el-table-column prop="order_num" label="订单编号" width="180">
				</el-table-column>
				<el-table-column prop="nickname" label="用户昵称" width="180">
				</el-table-column>
				<el-table-column prop="enter_name" label="真实姓名" width="180">
				</el-table-column>
				<el-table-column prop="remark" label="充值属性" width="180">
					<template slot-scope="scope">
						<div v-if="scope.row.type == 0">
							余额充值
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="price" label="充值金额" width="180">
				</el-table-column>
				<el-table-column prop="start_time" label="充值时间" width="180">
				</el-table-column>
				<el-table-column prop="pay_kind" label="充值平台" width="180">
				</el-table-column>
				<el-table-column prop="mobile" label="操作" width="180">
					<template slot-scope="scope">
						<el-button size="mini" @click="handinfo(scope.row)">充值详情</el-button>
					</template>
				</el-table-column>
			</el-table>
			<Pageing :page="page" :size="size" :total="total" @current-change="handleChangePage"></Pageing>
		</el-card>
		
		<el-dialog title="详情信息" :visible.sync="dialogFormVisible">
		  <el-form :model="forminfo">
		    <el-form-item label="订单编号" :label-width="formLabelWidth">
		      <el-input v-model="forminfo.order_num" disabled autocomplete="off"></el-input>
		    </el-form-item>
			<el-form-item label="用户昵称" :label-width="formLabelWidth">
			  <el-input v-model="forminfo.nickname" disabled autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item label="真实姓名" :label-width="formLabelWidth">
			  <el-input v-model="forminfo.enter_name" disabled autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item label="身份证号" :label-width="formLabelWidth">
			  <el-input v-model="forminfo.user_idcard" disabled autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item label="收益金额" :label-width="formLabelWidth">
			  <el-input v-model="forminfo.price" disabled autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item label="收益时间" :label-width="formLabelWidth">
			  <el-input v-model="forminfo.start_time" disabled autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item label="备注" :label-width="formLabelWidth">
			  <el-input v-model="forminfo.remark" disabled autocomplete="off"></el-input>
			</el-form-item>
		  </el-form>
		  <div slot="footer" class="dialog-footer">
		    <el-button @click="dialogFormVisible = false">取 消</el-button>
		    <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
		  </div>
		</el-dialog>
	</div>
</template>

<script>
	import Pageing from '../../components/page/page.vue'
	import {
		getComeList
	} from '../../api/board.js'
	export default {
		components: {
			Pageing
		},
		data() {
			return {
				formLabelWidth: '120px',
				dialogFormVisible:false,
				page:1,
				size:10,
				total:0,
				tableData: [],
				runmoney:0,
				checkAll: false,
				form: {
					checkList: [],
					orderid: '',
					time: '',
				},
				forminfo:{},
				incomeInfo:[],
				typelist: [{
						type: 0,
						name: '充值统计'
					},
					{
						type: 9,
						name: '付费观看抽成'
					},
					{
						type: 13,
						name: '委托抽成收入'
					},
					{
						type: 11,
						name: '图力抽成'
					}
				]
				
			};
		},
		mounted() {
			this.getuserlist()
		},
		methods: {
			resetForm(){
				this.form.checkList = []
				this.form.orderid =''
				this.form.time =''
				this.getuserlist()
			},
			getuserlist(){
				getComeList({
					page:this.page,
					where:this.form
				}).then(res=>{
					this.runmoney = res.allmoney
					this.tableData = res.list.data
					this.total = res.list.total
					this.incomeInfo = res.incomeInfo
					//console.log(res);
				})
				
			},
			handinfo(e){
				console.log(e);
				this.dialogFormVisible = true
				this.forminfo = e
			},
			submitForm() {
				this.getuserlist()
			},
			handleChangePage(val){
				this.page = val
				this.getuserlist()
			}
			
		}
	};
</script>

<style lang="less" scoped>
	.runmoney{
		display: flex; 
		flex-direction: column;
		align-items: center;
	}
	.top{
		display: flex;
		justify-content: center;
	}
	.top2{
		width: 200px;
		height: 32px;
	}
</style>
